import { render, staticRenderFns } from "./approveList.vue?vue&type=template&id=91d5f660&scoped=true&"
import script from "./approveList.vue?vue&type=script&lang=js&"
export * from "./approveList.vue?vue&type=script&lang=js&"
import style0 from "./approveList.vue?vue&type=style&index=0&id=91d5f660&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91d5f660",
  null
  
)

export default component.exports